/** A sheet as the prototype draws it: a centred dialog on a computer or an iPad, and on a phone a full-height sheet from the bottom. */
import { type ReactNode, useEffect } from "react";
import { Button } from "../components/ui/Button";
import { Icon, type IconName } from "../components/ui/Icon";

export function TalkSheet({ phone, title, lead, onClose, primary, children }: {
  phone: boolean;
  title: string;
  lead?: string;
  onClose: () => void;
  primary: { label: string; icon: IconName; disabled?: boolean; onClick: () => void };
  children: ReactNode;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (phone) {
    return (
      <div className="hp-veil" onClick={onClose}>
        <div className="hp-sheet full" role="dialog" aria-label={title} onClick={(e) => e.stopPropagation()}>
          <span className="hp-grab" aria-hidden="true" />
          <header className="hp-sheet-h">
            <h2>{title}</h2>
            <button type="button" className="hp-ib" aria-label="Close" onClick={onClose}>
              <Icon name="x" />
            </button>
          </header>
          <div className="hp-sheet-b">
            {lead ? <p className="hp-sheet-l">{lead}</p> : null}
            {children}
          </div>
          <div className="hp-sheet-f">
            <button type="button" className="hp-primary" disabled={primary.disabled} onClick={primary.onClick}>
              <Icon name={primary.icon} />
              {primary.label}
            </button>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="veil" onClick={onClose}>
      <div className="card sheet q-sheet" role="dialog" aria-label={title} onClick={(e) => e.stopPropagation()}>
        <h2>{title}</h2>
        {lead ? <p className="sheet-l">{lead}</p> : null}
        {children}
        <div className="sheet-acts">
          <Button onClick={onClose}>Not now</Button>
          <Button variant="p" icon={primary.icon} disabled={primary.disabled} onClick={primary.onClick}>
            {primary.label}
          </Button>
        </div>
      </div>
    </div>
  );
}
